export const SET_APP_DATA = 'app/SET_APP_DATA';
export const SET_APP_USER = 'app/SET_APP_USER';
export const SET_APP_NOTIFICATIONS = 'app/SET_APP_NOTIFICATIONS';
export const READ_NOTIFICATION = 'app/READ_NOTIFICATION';
export const UPDATE_USER_COUNTS = 'app/UPDATE_USER_COUNTS';
export const SET_FAMILY_DATA = 'app/SET_FAMILY_DATA';
export const LOG_OUT_USER = 'app/LOG_OUT_USER';
export const APP_HEARTBEAT = 'app/APP_HEARTBEAT';
